export const defaultRbac = (restaurant) => {
    const rbac = {
        "_resources": {
            "courierapp": {
                "name": "Courier App",
                "description": "Application for couriers",
                "_resources": {
                    "courierapp.view": {
                        "name": "View",
                        "description": "",
                        "_resources": {}
                    },
                    "courierapp.registerpayment": {
                        "name": "Register payment",
                        "description": "",
                        "_resources": {}
                    },
                    "courierapp.selfassign": {
                        "name": "Self Assign",
                        "description": "Assign to him/herself",
                        "_resources": {}
                    }
                }
            },
            "reports": {
                "name": "Reports",
                "description": "Reports",
                "_resources": {
                    "reports.todaytraffic": {
                        "name": "Today\'s traffic",
                        "description": "Printing daily closure reports",
                        "_resources": {}
                    },
                    "reports.prebookedorders": {
                        "name": "Prebooked orders",
                        "description": "Prebooked orders",
                        "_resources": {}
                    },
                    "reports.tableoccupations": {
                        "name": "Orders",
                        "description": "Live and closed orders",
                        "_resources": {
                            "reports.tableoccupations.revert": {
                                "name": "Revert",
                                "description": "Revert payment",
                                "_resources": {}
                            },
                            "reports.tableoccupations.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    },
                    "reports.traffic": {
                        "name": "Traffic",
                        "description": "Financial report for a period",
                        "_resources": {}
                    },
                    "reports.dailyclosing": {
                        "name": "Napi zárás",
                        "description": "Daily financial report",
                        "_resources": {}
                    },
                    "reports.bi": {
                        "name": "BI Reports",
                        "description": "Bi Reports",
                        "_resources": {
                            "reports.bi.financial": {
                                "name": "Revenue",
                                "_resources": {}
                            },
                            "reports.bi.rating": {
                                "name": "Rating analysis",
                                "_resources": {}
                            },
                            "reports.bi.profit": {
                                "name": "Profit analysis",
                                "_resources": {}
                            },
                            "reports.bi.financial_day": {
                                "name": "Daily revenue",
                                "_resources": {}
                            },
                            "reports.bi.delivery": {
                                "name": "Delivery analysis",
                                "_resources": {}
                            },
                            "reports.bi.customers": {
                                "name": "Customer analysis",
                                "_resources": {}
                            }
                        }
                    },
                    "reports.menuitems": {
                        "name": "Products",
                        "description": "Product list export",
                        "_resources": {}
                    }
                }
            },
            "newsletter": {
                "name": "Newsletter",
                "_resources": {}
            },
            "ntak": {
                "name": "NTAK",
                "_resources": {}
            },
            "administration": {
                "name": "Administration",
                "_resources": {
                    "administration.bankterminals": {
                        "name": "Bank Terminals",
                        "_resources": {}
                    },
                    "administration.servings": {
                        "name": "Servings",
                        "_resources": {}
                    },
                    "administration.menuchangelog": {
                        "name": "Menu change log",
                        "_resources": {}
                    },
                    "administration.discounts": {
                        "name": "Discounts",
                        "_resources": {}
                    },
                    "administration.restaurants": {
                        "name": "Restaurants",
                        "_resources": {}
                    },
                    "administration.productionlines": {
                        "name": "Production Lines",
                        "_resources": {}
                    },
                    "administration.tables": {
                        "name": "Tables",
                        "_resources": {}
                    },
                    "administration.advertisements": {
                        "name": "Advertisements",
                        "_resources": {}
                    },
                    "administration.wolt": {
                        "name": "Wolt",
                        "_resources": {}
                    },
                    "administration.products": {
                        "name": "Products",
                        "_resources": {
                            "administration.products.fullaccess": {
                                "name": "Full Access",
                                "description": "Full access to product management",
                                "_resources": {}
                            },
                            "administration.products.limitedaccess": {
                                "name": "Limited access",
                                "description": "Limited access to product management",
                                "_resources": {}
                            }
                        }
                    },
                    "administration.falatozz": {
                        "name": "Falatozz",
                        "_resources": {}
                    },
                    "administration.vatcategories": {
                        "name": "Vat Categories",
                        "_resources": {}
                    },
                    "administration.foodpanda": {
                        "name": "Foodpanda",
                        "_resources": {}
                    },
                    "administration.cashregisters": {
                        "name": "Cash Registers",
                        "_resources": {}
                    },
                    "administration.labels": {
                        "name": "Labels",
                        "_resources": {}
                    },
                    "administration.scales": {
                        "name": "Scales",
                        "_resources": {}
                    },
                    "administration.rbac": {
                        "name": "RBAC",
                        "description": "Access Roles Management",
                        "_resources": {}
                    },
                    "administration.printers": {
                        "name": "Printers",
                        "_resources": {}
                    }
                }
            },
            "sales": {
                "name": "Sales",
                "_resources": {
                    "sales.printinvoice": {
                        "name": "Print Invoice",
                        "_resources": {}
                    },
                    "sales.revert": {
                        "name": "Revert",
                        "description": "Revert paid orders",
                        "_resources": {}
                    },
                    "sales.pickup": {
                        "name": "Pickup",
                        "description": "",
                        "_resources": {
                            "sales.pickup.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            },
                            "sales.pickup.closeorders": {
                                "name": "Close orders",
                                "description": "Close pickup orders",
                                "_resources": {}
                            }
                        }
                    },
                    "sales.tablesoverview": {
                        "name": "Tables overview",
                        "description": "",
                        "_resources": {
                            "sales.tablesoverview.modify": {
                                "name": "Modify table layout",
                                "description": "",
                                "_resources": {}
                            },
                            "sales.tablesoverview.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    },
                    "sales.pointofsale": {
                        "name": "Point of sale",
                        "description": "",
                        "_resources": {}
                    },
                    "sales.settings": {
                        "name": "Settings",
                        "description": "Sales settings",
                        "_resources": {}
                    },
                    "sales.always_allow_delete": {
                        "name": "Delete orders",
                        "description": "Always allow delete orders",
                        "_resources": {}
                    },
                    "sales.registerpayment": {
                        "name": "Register payment",
                        "_resources": {}
                    },
                    "sales.dailyreport": {
                        "name": "Daily Closure Report",
                        "_resources": {
                            "sales.dailyreport.limited": {
                                "name": "Limited",
                                "description": "",
                                "_resources": {}
                            },
                            "sales.dailyreport.fullreport": {
                                "name": "Full report",
                                "_resources": {}
                            }
                        }
                    },
                    "sales.homedelivery": {
                        "name": "Home delivery",
                        "description": "",
                        "_resources": {
                            "sales.homedelivery.closeorders": {
                                "name": "Close orders",
                                "description": "Close homedelivery orders",
                                "_resources": {}
                            },
                            "sales.homedelivery.assigntocourier": {
                                "name": "Assign to courier",
                                "description": "Assign orders to courier",
                                "_resources": {}
                            },
                            "sales.homedelivery.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    }
                }
            },
            "serving": {
                "name": "Serving",
                "_resources": {}
            },
            "guestscreen": {
                "name": "Guest Screen",
                "_resources": {}
            },
            "bar": {
                "name": "Bar",
                "_resources": {}
            },
            "stockmanagement": {
                "name": "Stock Management",
                "_resources": {
                    "stockmanagement.barcodes": {
                        "name": "Barcode management",
                        "_resources": {}
                    },
                    "stockmanagement.stockmovements": {
                        "name": "Stock Movements",
                        "_resources": {
                            "stockmanagement.stockmovements.delete": {
                                "name": "Delete",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.stockmovements.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.stockmovements.modify": {
                                "name": "Modify",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.stockmovements.add": {
                                "name": "Add",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    },
                    "stockmanagement.incomingstocks": {
                        "name": "Incoming Stocks",
                        "_resources": {
                            "stockmanagement.incomingstocks.delete": {
                                "name": "Delete",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.incomingstocks.modify": {
                                "name": "Modify",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.incomingstocks.add": {
                                "name": "Add",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.incomingstocks.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    },
                    "stockmanagement.stocklist": {
                        "name": "Stocklist",
                        "_resources": {}
                    },
                    "stockmanagement.shoppinglist": {
                        "name": "Shopping list",
                        "_resources": {}
                    },
                    "stockmanagement.inventories": {
                        "name": "Inventories",
                        "_resources": {
                            "stockmanagement.inventories.add": {
                                "name": "Add",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.inventories.delete": {
                                "name": "Delete",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.inventories.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.inventories.modify": {
                                "name": "Modify",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    },
                    "stockmanagement.inventorytemplates": {
                        "name": "Inventory Templates",
                        "_resources": {
                            "stockmanagement.inventorytemplates.add": {
                                "name": "Add",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.inventorytemplates.delete": {
                                "name": "Delete",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.inventorytemplates.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.inventorytemplates.modify": {
                                "name": "Modify",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    },
                    "stockmanagement.stockstatistics": {
                        "name": "Stock Statistics",
                        "_resources": {}
                    },
                    "stockmanagement.stores": {
                        "name": "Stores",
                        "_resources": {
                            "stockmanagement.stores.modify": {
                                "name": "Modify",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.stores.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.stores.delete": {
                                "name": "Delete",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.stores.add": {
                                "name": "Add",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    },
                    "stockmanagement.pandl": {
                        "name": "Profit And Loss Analytics",
                        "_resources": {}
                    },
                    "stockmanagement.inventoryscrapping": {
                        "name": "Inventory Scrapping",
                        "_resources": {
                            "stockmanagement.inventoryscrapping.delete": {
                                "name": "Delete",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.inventoryscrapping.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.inventoryscrapping.add": {
                                "name": "Add",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.inventoryscrapping.modify": {
                                "name": "Modify",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    },
                    "stockmanagement.suppliers": {
                        "name": "Suppliers",
                        "_resources": {
                            "stockmanagement.suppliers.add": {
                                "name": "Add",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.suppliers.modify": {
                                "name": "Modify",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.suppliers.view": {
                                "name": "View",
                                "description": "",
                                "_resources": {}
                            },
                            "stockmanagement.suppliers.delete": {
                                "name": "Delete",
                                "description": "",
                                "_resources": {}
                            }
                        }
                    },
                    "stockmanagement.viewstock": {
                        "name": "View actual stock",
                        "description": "",
                        "_resources": {}
                    }
                }
            },
            "waiter": {
                "name": "Waiter Screen",
                "_resources": {}
            },
            "kiosk": {
                "name": "Kiosk",
                "_resources": {}
            },
            "kitchen": {
                "name": "KDS",
                "description": "Kitchen display system",
                "_resources": {}
            },
            "tablebooking": {
                "name": "Table Booking",
                "_resources": {
                    "tablebooking.book": {
                        "name": "Book",
                        "description": "",
                        "_resources": {}
                    },
                    "tablebooking.settings": {
                        "name": "Settings",
                        "description": "",
                        "_resources": {}
                    },
                    "tablebooking.view": {
                        "name": "View",
                        "description": "",
                        "_resources": {}
                    }
                }
            }
        },
        "_roles": {
            "courier": {
                "readonly": true,
                "permissions": [
                    "courierapp.view"
                ]
            },
            "cook": {
                "readonly": true,
                "permissions": [
                    "kitchen"
                ]
            },
            "admin": {
                "readonly": true,
                "permissions": [
                    "ntak",
                    "serving",
                    "bar",
                    "stockmanagement",
                    "stockmanagement.inventorytemplates",
                    "kitchen",
                    "tablebooking",
                    "waiter",
                    "sales",
                    "kiosk",
                    "reports",
                    "newsletter",
                    "guestscreen",
                    //all administration permissions but rbac
                    "administration.bankterminals",
                    "administration.servings",
                    "administration.menuchangelog",
                    "administration.discounts",
                    "administration.restaurants",
                    "administration.productionlines",
                    "administration.tables",
                    "administration.advertisements",
                    "administration.wolt",
                    "administration.products.fullaccess",
                    "administration.falatozz",
                    "administration.vatcategories",
                    "administration.foodpanda",
                    "administration.cashregisters",
                    "administration.labels",
                    "administration.scales",
                    "administration.printers",
                ]
            },
            "store": {
                "readonly": true,
                "permissions": [
                    "stockmanagement"
                ]
            },
            "waiter": {
                "readonly": true,
                "permissions": [
                    "bar",
                    "kitchen",
                    "tablebooking",
                    "waiter",
                    "administration.products.limitedaccess",
                    "guestscreen",
                    "serving",
                    "kiosk",
                    "sales.dailyreport.limited",
                    "sales.dailyreport.fullreport",
                    "sales.printinvoice",
                    "sales.registerpayment",
                    "sales.homedelivery.assigntocourier",
                    "sales.dailyreport.limited",
                    "sales.homedelivery.closeorders",
                    "sales.pickup.closeorders",
                    "sales.pointofsale",
                    "sales.tablesoverview.view",
                    "sales.homedelivery.view",
                    "sales.pickup.view",
                    "stockmanagement.inventories.add",
                    "stockmanagement.inventoryscrapping.add"
                ]
            },
            "finance": {
                "readonly": true,
                "permissions": [
                    "reports"
                ]
            }
        }
    };

    if (restaurant?.settings?.["tables-overview"]?.block_waiter_print_daily_closing === false) {
        if (!rbac._roles.waiter.permissions.includes('sales.dailyreport.limited')) {
            rbac._roles.waiter.permissions.push('sales.dailyreport.limited');
        }
    }

    if (restaurant?.settings?.["tables-overview"]?.waiter_print_daily_closing_full === true) {
        if (!rbac._roles.waiter.permissions.includes('sales.dailyreport.fullreport')) {
            rbac._roles.waiter.permissions.push('sales.dailyreport.fullreport');
        }
    }

    if (restaurant?.settings?.["tables-overview"]?.block_waiter_print_invoice === false) {
        if (!rbac._roles.waiter.permissions.includes('sales.printinvoice')) {
            rbac._roles.waiter.permissions.push('sales.printinvoice');
        }
    }

    if (restaurant?.settings?.["tables-overview"]?.always_allow_delete === true) {
        if (!rbac._roles.waiter.permissions.includes('sales.always_allow_delete')) {
            rbac._roles.waiter.permissions.push('sales.always_allow_delete');
        }
    }

    if (restaurant?.settings?.["tables-overview"]?.homedelivery?.blockWaiterClose === false) {
        if (!rbac._roles.waiter.permissions.includes('sales.homedelivery.closeorders')) {
            rbac._roles.waiter.permissions.push('sales.homedelivery.closeorders');
        }
        if (!rbac._roles.waiter.permissions.includes('sales.pickup.closeorders')) {
            rbac._roles.waiter.permissions.push('sales.pickup.closeorders');
        }
    }
    
    if (restaurant?.settings?.["tables-overview"]?.block_waiter_register_payment === false) {
        if (!rbac._roles.waiter.permissions.includes('sales.registerpayment')) {
            rbac._roles.waiter.permissions.push('sales.registerpayment');
        }
    }

    // SQL equivalent of the above logic to update existing restaurants in DB
 
    return rbac;
}